var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("HeadbarPage", { attrs: { title: "Títulos > Cessão de Títulos" } }),
      _c(
        "v-card",
        { staticClass: "mt-2 mb-3" },
        [
          _c(
            "v-row",
            { staticClass: "mx-6 mt-3 pt-3" },
            [
              _c("v-col", [
                _c(
                  "span",
                  {
                    staticClass: "text-left font-weight-black display-1 pl-0",
                    style: { color: _vm.primaryColorFont }
                  },
                  [_vm._v("Cessão de Títulos")]
                )
              ])
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "mx-6" },
            [
              _c("v-col", { attrs: { cols: "12", sm: "12", md: "12" } }, [
                _c(
                  "div",
                  { staticClass: "ghost-card" },
                  [
                    _c("div", { staticClass: "mb-5" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("Filtros de Cessão")
                      ])
                    ]),
                    _c(
                      "v-row",
                      { staticClass: "mb-3" },
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "12", md: "6" } },
                          [
                            _c("v-select", {
                              attrs: {
                                outlined: "",
                                dense: "",
                                items: _vm.apresentantes,
                                label: "Apresentante Origem",
                                "item-text": "cd_apresentante",
                                "item-value": "cd_apresentante",
                                rules: [
                                  v =>
                                    !!v || "Apresentante Origem é obrigatório"
                                ],
                                required: ""
                              },
                              model: {
                                value: _vm.filtros.apresentanteOrigem,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filtros,
                                    "apresentanteOrigem",
                                    $$v
                                  )
                                },
                                expression: "filtros.apresentanteOrigem"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("v-textarea", {
                      attrs: {
                        solo: "",
                        small: "",
                        label:
                          "Inserir Títulos (ds_nosso_numero ou id_titulo) *",
                        hint:
                          "Insira os códigos dos títulos (ds_nosso_numero ou id_titulo) separados por vírgulas, exemplo: 477977/1, 721603/6, 755202/5, 55555, 44444, 222222",
                        placeholder:
                          "Cole aqui os títulos que deseja transferir",
                        rules: [v => !!v || "Campo obrigatório"],
                        required: ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "append",
                          fn: function() {
                            return [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "v-icon--clearable",
                                  on: { click: _vm.limparCampo }
                                },
                                [_vm._v(" mdi-close ")]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ]),
                      model: {
                        value: _vm.filtros.ds_nosso_numero,
                        callback: function($$v) {
                          _vm.$set(_vm.filtros, "ds_nosso_numero", $$v)
                        },
                        expression: "filtros.ds_nosso_numero"
                      }
                    }),
                    _c(
                      "v-row",
                      { staticStyle: { width: "50%" } },
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "12", md: "12" } },
                          [
                            _c("div", { staticClass: "mb-5" }, [
                              _c("span", { staticClass: "title" }, [
                                _vm._v("Upload de Arquivo")
                              ])
                            ]),
                            _c(
                              "div",
                              { staticClass: "d-flex" },
                              [
                                _c("v-file-input", {
                                  key: _vm.counterRender,
                                  ref: "myFileInput",
                                  staticClass: "mb-n7 mr-2 white--text",
                                  attrs: {
                                    "prepend-icon": "",
                                    accept:
                                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xls, .xlsx, .xlsm",
                                    label: "Escolher arquivo ",
                                    "show-size": "",
                                    chips: "",
                                    dense: "",
                                    solo: "",
                                    id: "fileInput",
                                    name: "file"
                                  },
                                  on: { change: _vm.uploadFileReference },
                                  model: {
                                    value: _vm.file,
                                    callback: function($$v) {
                                      _vm.file = $$v
                                    },
                                    expression: "file"
                                  }
                                }),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "text-capitalize mr-2",
                                    on: {
                                      click: function($event) {
                                        return _vm.openUpload()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { staticClass: "ma-2 text-left" },
                                      [_vm._v(" mdi-upload ")]
                                    ),
                                    _vm._v(" upload ")
                                  ],
                                  1
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "text-capitalize",
                                    attrs: { href: _vm.link_modelo }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { staticClass: "ma-2 text-left" },
                                      [_vm._v(" mdi-download ")]
                                    ),
                                    _vm._v(" Baixar Modelo ")
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c("div", { staticClass: "my-5" }, [
                              _c("span", { staticClass: "sub-title" }, [
                                _vm._v(
                                  " Formatos compatíveis: .xls/.xlsx/.xlsm. Limite de tamanho: 60mb "
                                )
                              ])
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      { staticClass: "mt-5" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "d-flex justify-start",
                            attrs: { cols: "12", sm: "6" }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "white--text",
                                attrs: { color: "grey lighten-1" },
                                on: { click: _vm.limparFiltros }
                              },
                              [
                                _vm._v(" Limpar Filtros "),
                                _c("v-icon", { staticClass: "ml-2" }, [
                                  _vm._v("mdi-broom")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "d-flex justify-end",
                            attrs: { cols: "12", sm: "6" }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "primary",
                                  loading: _vm.loadingFiltros,
                                  disabled: !_vm.filtrosValidos
                                },
                                on: { click: _vm.botaoFiltrar }
                              },
                              [
                                _vm._v(" Filtrar "),
                                _c("v-icon", { staticClass: "ml-2" }, [
                                  _vm._v("mdi-magnify")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("TableWithSelections", {
        ref: "tableWithSelections",
        attrs: {
          titulos: _vm.titulos,
          totalTitulos: _vm.totalTitulos,
          loading: _vm.loading,
          headers: _vm.headers
        },
        on: {
          selecionados: _vm.setSelecionados,
          changeOptionsPage: _vm.changeOptionsPage,
          selecionarTodos: _vm.setTodosSelecionados
        }
      }),
      _c(
        "v-row",
        { staticClass: "ma-0" },
        [
          _c("v-spacer"),
          _c(
            "v-col",
            {
              staticClass: "d-flex justify-end pr-0",
              attrs: { sm: "6", md: "3", lg: "4" }
            },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { top: "", disabled: _vm.selecionados.length !== 0 },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function({ on }) {
                        return [
                          _c(
                            "div",
                            _vm._g({}, on),
                            [
                              _c(
                                "v-btn",
                                {
                                  directives: [
                                    {
                                      name: "intersect",
                                      rawName: "v-intersect",
                                      value: _vm.onIntersect,
                                      expression: "onIntersect"
                                    }
                                  ],
                                  staticClass: "d-flex justify-center",
                                  attrs: {
                                    color: "green white--text",
                                    disabled: !_vm.selecionados.length
                                  },
                                  on: { click: _vm.abrirModalCessao }
                                },
                                [
                                  _vm._v(" Cessão de Títulos "),
                                  _c("v-icon", { staticClass: "ml-2" }, [
                                    _vm._v("mdi-swap-horizontal-bold")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("span", [
                    _vm._v(
                      "Selecione um ou mais títulos para realizar a cessão"
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-btn",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.mostrarBotaoFlutuante,
              expression: "mostrarBotaoFlutuante"
            }
          ],
          staticClass: "botao-flutuante",
          attrs: {
            color: "green",
            dark: "",
            fab: "",
            fixed: "",
            right: "",
            bottom: "",
            disabled: !_vm.selecionados.length
          },
          on: { click: _vm.abrirModalCessao }
        },
        [_c("v-icon", [_vm._v("mdi-swap-horizontal-bold")])],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "900px",
            persistent: "",
            scrollable: "",
            color: "background",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.showModal,
            callback: function($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { flat: "", dark: "", color: "primary" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _vm.fecharModal }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(" Confirmação de Cessão de Títulos ")
                  ])
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                {
                  staticStyle: { "border-radius": "0" },
                  attrs: { "min-height": "200px" }
                },
                [
                  _c(
                    "v-list",
                    { attrs: { shaped: "" } },
                    [
                      _c(
                        "v-row",
                        { staticClass: "mb-3" },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { outlined: "" } },
                                [
                                  _c(
                                    "v-card-title",
                                    { staticClass: "subtitle-1" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-2",
                                          attrs: { color: "primary" }
                                        },
                                        [
                                          _vm._v(
                                            "mdi-arrow-up-bold-circle-outline"
                                          )
                                        ]
                                      ),
                                      _vm._v(" Apresentante Origem ")
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-card-text",
                                    { staticStyle: { "min-height": "80px" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getApresentanteNome(
                                              _vm.filtros.apresentanteOrigem
                                            )
                                          ) +
                                          " - " +
                                          _vm._s(
                                            _vm.filtros.apresentanteOrigem
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { outlined: "" } },
                                [
                                  _c(
                                    "v-card-title",
                                    { staticClass: "subtitle-1" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-2",
                                          attrs: { color: "green" }
                                        },
                                        [
                                          _vm._v(
                                            "mdi-arrow-down-bold-circle-outline"
                                          )
                                        ]
                                      ),
                                      _vm._v(" Apresentante Destino ")
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-card-text",
                                    { staticStyle: { "min-height": "80px" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          outlined: "",
                                          dense: "",
                                          items: _vm.apresentantes,
                                          label:
                                            "Selecione o Apresentante Destino",
                                          "item-text": "cd_apresentante",
                                          "item-value": "cd_apresentante",
                                          rules: [
                                            v =>
                                              !!v ||
                                              "Apresentante Destino é obrigatório"
                                          ],
                                          required: ""
                                        },
                                        model: {
                                          value:
                                            _vm.filtros.apresentanteDestino,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filtros,
                                              "apresentanteDestino",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "\n                                            filtros.apresentanteDestino\n                                        "
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-subheader",
                        {
                          staticClass: "primary--text title font-weight-black"
                        },
                        [
                          _vm._v(
                            " Títulos selecionados: " +
                              _vm._s(_vm.titulosSelecionados.length) +
                              " "
                          )
                        ]
                      ),
                      _c("v-data-table", {
                        staticClass: "elevation-1 mb-4",
                        attrs: {
                          headers: _vm.activeHeadersModal,
                          items: _vm.titulosSelecionados,
                          "disable-sort": "",
                          "items-per-page": 10
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm.tituloSearch
                              ? {
                                  key: `item.comentario`,
                                  fn: function({ item }) {
                                    return [
                                      _c("v-text-field", {
                                        attrs: {
                                          dense: "",
                                          outlined: "",
                                          "hide-details": "",
                                          "single-line": "",
                                          placeholder: "Adicionar comentário",
                                          maxlength: "2000",
                                          counter: "2000"
                                        },
                                        model: {
                                          value: item.comentario,
                                          callback: function($$v) {
                                            _vm.$set(item, "comentario", $$v)
                                          },
                                          expression: "item.comentario"
                                        }
                                      })
                                    ]
                                  }
                                }
                              : null,
                            {
                              key: `item.actions`,
                              fn: function({ item }) {
                                return [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { small: "", color: "error" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removerTitulo(item)
                                        }
                                      }
                                    },
                                    [_vm._v(" mdi-delete ")]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      }),
                      !_vm.tituloSearch || !Array.isArray(_vm.tituloSearch)
                        ? _c(
                            "v-subheader",
                            {
                              staticClass:
                                "primary--text title font-weight-black"
                            },
                            [_vm._v(" Observação da Cessão ")]
                          )
                        : _vm._e(),
                      (!_vm.tituloSearch || !Array.isArray(_vm.tituloSearch)) &&
                      _vm.titulosSelecionados.length > 0
                        ? _c("v-textarea", {
                            attrs: {
                              outlined: "",
                              label: "Insira uma observação para esta cessão",
                              rows: "3",
                              maxlength: "2000",
                              counter: "2000"
                            },
                            model: {
                              value: _vm.comentarioCessao,
                              callback: function($$v) {
                                _vm.comentarioCessao = $$v
                              },
                              expression: "comentarioCessao"
                            }
                          })
                        : _vm._e(),
                      _c("v-text-field", {
                        staticStyle: { width: "25%" },
                        attrs: {
                          maxlength: "20",
                          dense: "",
                          outlined: "",
                          "hide-details": "",
                          "single-line": "",
                          placeholder: "Código da Carteira"
                        },
                        model: {
                          value: _vm.filtros.cd_carteira,
                          callback: function($$v) {
                            _vm.$set(_vm.filtros, "cd_carteira", $$v)
                          },
                          expression: "filtros.cd_carteira"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-2",
                      attrs: { disabled: _vm.loadingCessao },
                      on: { click: _vm.fecharModal }
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-2",
                      attrs: {
                        color: "success",
                        loading: _vm.loadingCessao,
                        disabled:
                          _vm.titulosSelecionados.length === 0 ||
                          !_vm.filtros.apresentanteDestino
                      },
                      on: { click: _vm.confirmarCessao }
                    },
                    [
                      _c("v-icon", { staticClass: "mr-2" }, [
                        _vm._v("mdi-check-circle")
                      ]),
                      _vm._v(" Confirmar Cessão de Títulos ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.snackbar
        ? _c("Snackbar", {
            attrs: {
              mostrarSnackbar: _vm.snackbar,
              corSnackbar: _vm.colorSnackbar,
              mensagemSnackbar: _vm.mensagemSnackbar
            },
            on: {
              fecharSnackbar: function($event) {
                _vm.snackbar = false
              }
            }
          })
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "800px",
            persistent: "",
            scrollable: "",
            color: "background",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialogError,
            callback: function($$v) {
              _vm.dialogError = $$v
            },
            expression: "dialogError"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { flat: "", dark: "", color: "error" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function($event) {
                          _vm.dialogError = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v("Erro")])
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "font-weight-black" },
                            [
                              _c("v-icon", { staticClass: "ma-1" }, [
                                _vm._v("mdi-alert")
                              ]),
                              _vm._v(" Erro ao enviar a arquivo de upload ")
                            ],
                            1
                          ),
                          _c("v-card-text", [
                            _vm._v(
                              " Houve um erro ao ler o arquivo de upload. Por favor, tente novamente. "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-2",
                      attrs: { color: "error" },
                      on: {
                        click: function($event) {
                          _vm.dialogError = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")]), _vm._v("Fechar ")],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }